import TableSearch from '@rio-cloud/rio-uikit/TableSearch';

type SearchInputProps = {
    value: string;
    onSearch: (value: string) => void;
    placeholder?: string;
};

export const SearchInput = ({ value, onSearch, placeholder = 'Search' }: SearchInputProps) => {
    return <TableSearch placeholder={placeholder} value={value} onChange={onSearch} />;
};
